const React = require('react')
const PropTypes = require('prop-types')

require('@styles/components/boxes.css')

const Boxes = props => {
    return (
        <div className='statistics-boxes'>
            {props.items.map((item, index) => (
                <div key={index} className='statistics-box'>
                    <div className='statistics-box-sub-title'>{item.title}</div>
                    <div className='statistics-box-value'>{item.value}</div>
                </div>
            ))}
        </div>
    )
}

Boxes.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
        })
    ).isRequired
}

module.exports = { Boxes }
